import { AuthGuard } from '../../../shared/services';
import { CategoryAssociationDetailsComponent } from './category-association-details.component';
import { CategoryAssociationDetailsResolver } from './category-association-details.resolver';
import { Route } from '@angular/router';
export const CategoryAssociationDetailsRoutes: Route[] = [
  {
    path: ':id',
    component: CategoryAssociationDetailsComponent,
    canActivate: [AuthGuard],
    resolve: {
      category: CategoryAssociationDetailsResolver
    }
  }
];
